// Фронт-флаги разделов, которые временно выключены.

// Партнёрская программа: рефералки, промокоды, расчёты соответствия в карточке корпа,
// кнопка «Корпоративный клиент» в шапке. Возвращаем на этапе партнёрской программы.
export const PARTNER_FEATURES = false;
